import { render, staticRenderFns } from "./UpcomingRoutes.vue?vue&type=template&id=40965a84&"
import script from "./UpcomingRoutes.vue?vue&type=script&lang=js&"
export * from "./UpcomingRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports